import $ from 'jquery';

import 'slick-carousel';

class Carousel {
    constructor(carousel) {
        $(carousel).find('.pi-carousel__slides').slick({
            centerMode: true,
            centerPadding: '25%',
            slidesToShow: 1,
            prevArrow: '.pi-carousel__prev',
            nextArrow: '.pi-carousel__next',
            dots: true,
            dotsClass: 'pi-carousel__pagination',
            responsive: [
                {
                  breakpoint: 480,
                  settings: {
                    arrows: false,
                    centerPadding: '25px',
                  }
                }
            ]
        });

        this.events();
    }

    events() {

    }
}

const init = () => {
    for(const carousel of $('.pi-carousel')) {
        new Carousel(carousel);
    }
};

export default {
    init
};



// WEBPACK FOOTER //
// ./src/scripts/blocks/carousel.js